import { Link } from 'react-router';

/**
 * The Guardian mark: a shield in the brand orange, filled with a lit edge, beside the name in the
 * body face — the template's small solid mark and plain wordmark.
 */
export function Logo({ to = '/', size = 28 }: { to?: string; size?: number }) {
  return (
    <Link to={to} className="logo" aria-label="Guardian AI home">
      <svg width={size * 0.8} height={size * 0.8} viewBox="0 0 32 32" aria-hidden="true">
        <defs>
          <linearGradient id="guardian-mark" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#ffb547" />
            <stop offset="1" stopColor="var(--brand)" />
          </linearGradient>
        </defs>
        <path
          d="M16 3 L27 8 V16 C27 22.5 22 27 16 29 C10 27 5 22.5 5 16 V8 Z"
          fill="url(#guardian-mark)"
        />
        <path d="M16 9 V20" stroke="var(--bg)" strokeWidth="2.6" strokeLinecap="round" />
      </svg>
      <span
        style={{
          fontSize: size * 0.72,
          fontWeight: 500,
          color: 'var(--text)',
          letterSpacing: '0.01em',
        }}
      >
        Guardian AI
      </span>
    </Link>
  );
}
